import { Component } from '@angular/core';

import { CallStatusService } from '../core';

import { TranslationKeyMap } from './call-hud.i18n';

@Component({
    selector: 'cmps-teamscall-call-hud',
    templateUrl: './call-hud.component.html',
    host: {
        class: 'cmps-teamscall-call-hud',
    },
})
export class CallHudComponent {
    /** @private */
    _i18n = TranslationKeyMap;

    constructor(/** @private */ readonly _service: CallStatusService) {}
}
